import * as React from 'react';
import { colors } from '../../../index';

const IconLocation = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 26 38",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.239 31.8c.94-2.581 3.04-4.746 5.234-7.003C22.68 21.495 26 18.082 26 13c0-7.168-5.832-13-13-13S0 5.832 0 13c0 5.082 3.319 8.495 6.527 11.797 2.194 2.257 4.295 4.422 5.234 7.002-4.446.147-6.705 1.108-6.705 2.868 0 1.916 2.673 2.889 7.944 2.889s7.944-.973 7.944-2.89c0-1.76-2.259-2.72-6.705-2.867zM1.444 13C1.444 6.629 6.63 1.444 13 1.444c6.371 0 11.556 5.185 11.556 11.556 0 4.496-2.972 7.553-6.12 10.79-2.142 2.204-4.336 4.462-5.436 7.202-1.1-2.74-3.295-4.998-5.437-7.202C4.416 20.553 1.444 17.496 1.444 13zM13 36.111c-4.77 0-6.5-.864-6.5-1.444 0-.545 1.524-1.34 5.652-1.435.043.24.074.483.095.731-1.408.065-3.099.298-3.099.704 0 .481 2.39.722 3.852.722 1.463 0 3.852-.24 3.852-.722 0-.406-1.691-.64-3.099-.704.021-.248.052-.492.095-.73 4.128.095 5.652.89 5.652 1.434 0 .58-1.73 1.444-6.5 1.444z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.778 13A5.785 5.785 0 0013 7.222 5.785 5.785 0 007.222 13 5.785 5.785 0 0013 18.778 5.785 5.785 0 0018.778 13zM8.667 13A4.338 4.338 0 0113 8.667 4.338 4.338 0 0117.333 13 4.338 4.338 0 0113 17.333 4.338 4.338 0 018.667 13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.222 13h1.445c0-4.779-3.888-8.667-8.667-8.667v1.445c3.982 0 7.222 3.24 7.222 7.222z"
  }));
};

export default IconLocation;